// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__7WNUv","body":"Dialog_body__sBhTC"};